import store from "@/store/main";
import Storage from "@/utils/storage";
import Config from "@/config";
import { addToken, getQueryValue, getQueryObject } from "@/utils";
import { thirdLogin } from "./thirdLogin";

const user = import(
  /*
  webpackChunkName: "store-user"
   */
  "@/store/modules/user"
);
const app = import(
  /*
  webpackChunkName: "store-app"
   */
  "@/store/modules/app"
);

async function syncLoginState() {
  // 同步登陆状态

  const passport_user_info = Storage.get("passport_user_info") || "";
  const passport_api_token = Storage.get("passport_api_token") || "";
  const passport_identity_token = Storage.get("passport_identity_token") || "";

  if (passport_user_info && passport_api_token) {
    Storage.set("account_api_token", passport_api_token);
    Storage.set("account_user", passport_user_info);
    Storage.set("account_id_token", passport_identity_token);
    store.dispatch("UpdateApiToken", passport_api_token);
    store.dispatch("UpdateUserInfo", passport_user_info);
    store.dispatch("UpdateIdentityToken", passport_identity_token);
  }

  // const userInfo = Storage.get("userInfo");
  // const identityToken = Storage.get("identityToken");
  // const apiToken = Storage.get("apiToken");
  // if (identityToken && userInfo) {
  //   await store.dispatch("UpdateIdentityToken", identityToken);
  //   await store.dispatch("UpdateUserInfo", userInfo);
  // }
  // if (userInfo && identityToken && apiToken) {
  //   await store.dispatch("SyncLoginState", {
  //     api_token: apiToken,
  //     identity_token: identityToken,
  //     user: userInfo,
  //   });
  // }
  // if (document.documentElement.lang === "zh") {
  thirdLogin();
  // }

  // 退出登录触发vuex
  setTimeout(() => {
    const el = document.querySelector(".headerUserInfo > span");
    if (el) {
      el.addEventListener("click", () => {
        store.dispatch("Logout");
      });
    }
  }, 0);

  // 获取Appid
  // if (!Storage.get("appId")) {
  //   await store.dispatch("getAppId", Config.myaccountAppName);
  // }

  //微信自动登录
  let userApiToken = Storage.get("apiToken");
  let code = getQueryValue("code");
  let weixin_auto_login = getQueryValue("weixin_auto_login");
  let UA = window.navigator.userAgent.toLowerCase();
  let isMicroMessenger = UA && UA.indexOf("micromessenger") > 0;
  if (isMicroMessenger && !code && !userApiToken) {
    // 带有特定参数且浏览器为微信浏览器,跳转
    let appid = "wxd6d7038d8f2449ea";
    let redirect_uri = encodeURIComponent(
      `https://gw.aoscdn.com/base/passport/v1/api/oauth/redirect?callback=${encodeURIComponent(
        window.location.href
      )}`
    );
    let state = "login";
    window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
  }
  if (isMicroMessenger && code && !userApiToken) {
    store.dispatch("LoginByCode", code);
  }

  // 获取地区码
  if (!Storage.get("areacodes")) {
    await store.dispatch("getAreaCodes");
  }

  // 如果请求参数中有 identityToken, 自动登录
  const identityTokenQuery = getQueryValue("identityToken");
  if (identityTokenQuery) {
    await store.dispatch("LoginByToken", identityTokenQuery);
    //登录后去除地址栏identityToken信息
    const state = getQueryObject(window.location.href);
    delete state.identityToken;
    const url = window.location.href.split("?")[0];
    let newStr = "";
    let flag = false;
    for (let [key, value] of Object.entries(state)) {
      if (flag) {
        newStr = newStr + "&";
      } else {
        newStr = newStr + "?";
        flag = true;
      }
      newStr = key + "=" + value;
    }
    window.history.pushState(null, null, url + "?" + newStr);
  }

  // 处理第三方登录回调
  const state = getQueryValue("state");
  const action = getQueryValue("action");
  if (action === "login" && state) {
    store
      .dispatch("LoginByState", state)
      .then(() => {
        const returnUrl = Storage.get("returnUrl");
        const identityToken = Storage.get("identityToken");
        if (returnUrl) {
          window.location.href = addToken(
            decodeURIComponent(returnUrl),
            identityToken
          ).toString();
        } else {
          window.location.href = addToken(
            window.location.origin + window.location.pathname,
            identityToken
          ).toString();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

function syncReturnURL() {
  // // 如果参数中带有returnUrl，则登录或者注册成功后，跳转到该地址
  const returnUrl = getQueryValue("returnUrl");
  if (returnUrl) {
    Storage.set("returnUrl", returnUrl);
  }
}

Promise.all([user, app]).then(([user, app]) => {
  store.registerModule("user", user.default);
  store.registerModule("app", app.default);
  (async function () {
    syncReturnURL();
    await syncLoginState();
  })();
});

export default store;
